import React from 'react';
import { getParametersFromUrl } from '../../../utils/url-utils/urlUtils';
import { Connect, PropsFromRedux } from './MarkNotificationAsReadContainer';

type Props = PropsFromRedux;

export class RawMarkNotificationAsRead extends React.Component<Props> {
  componentDidMount() {
    const currentUrl = window.location.href;
    if (currentUrl.includes('source_notification_id')) {
      const urlParamsMap = getParametersFromUrl(window.location.search);
      if (urlParamsMap) {
        const notificationId = parseInt(
          urlParamsMap.source_notification_id,
          10,
        );
        if (!Number.isNaN(notificationId)) {
          try {
            this.props.markNotificationAsRead(notificationId);
          } catch (error) {
            throw error;
          }
        }
      }
    }
  }

  render() {
    return null;
  }
}

export const MarkNotificationAsRead = Connect(RawMarkNotificationAsRead);
